import styled from 'styled-components';
import MessageIcon from '@bufferapp/ui/Icon/Icons/Message';
import {
  white,
  gray,
  grayLight,
  orangeLight,
  orangeLightest,
} from '@bufferapp/ui/style/colors';

export const CommentListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${grayLight};
  border-radius: 4px;
  background-color: ${white};
  padding: 10px 0;
  width: 340px;
  max-height: 630px;
`;

export const CommentsBadgeWrapper = styled.div<{ hasComments: boolean }>`
  position: relative;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  background: ${(props) => (props.hasComments ? orangeLight : gray)};
  /* color: ${(props) => (props.hasComments ? orangeLightest : white)}; */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const CommentsIcon = styled(MessageIcon).attrs({
  size: 'medium',
})`
  margin-top: 1px;
  color: ${white};
`;

export const Comments = styled.div`
  display: flex;
  flex-direction: column-reverse;
  overflow-y: scroll;
`;
